/* 
	在下方导入弹窗文件
	import xxx from 'xxx.vue'
	
	在DIALOG数组中注册组件
	DIALOG = [
		xxx
	]
	
	任意页面调用弹窗
	this.globalDialog(name, opt, resolve, cancel)
	可传入以下参数
	name: 弹窗name，对应弹窗文件中的name属性
	opt: {  传入弹窗的数据，包含两部分
		props: {...},  弹窗内props属性定义的变量值
		data: {...}  传入弹窗内open方法的数据
	}
	resolve:  确认回调函数，在弹窗内调用this.$emit('resolve')触发
	cancel: 取消回调函数，在弹窗内调用this.$emit('cancel')触发
	
	
	例如：
	this.globalDialog('staffSelector', {
		props: {
			multiple: true
		},
		data: {
			id: 1
		}
	}, this.aaa, this.bbb)
	
	等价于
	
	<staff-selector ref="staffSelector" :multiple="true" @resolve="aaa" @cancel="bbb"></staff-selector>
	this.$refs.staffSelector.open({
		id: 1
	});
 */

import router from '@/router';
import store from '@/store';

import salesOrderDetail from '@/pages/sales/order_detail.vue'
import offlineOrderPay from '@/pages/sales/order_offline_pay.vue'

import purchaseOrderDetail from '@/pages/purchase/order_detail.vue'

import repairRecordDetail from '@/pages/repair/record_detail.vue'
import repairDeliveryDetail from '@/pages/repair/delivery_detail.vue'

const DIALOG = [
	salesOrderDetail,
	offlineOrderPay,

	purchaseOrderDetail,

	repairRecordDetail,
	repairDeliveryDetail
]
const DIALOG_CACHE = {};
let zIndex = 1011;

export default {
	install: function(Vue) {
		function compareObjects(obj1, obj2) {
			const keys1 = Object.keys(obj1);
			const keys2 = Object.keys(obj2);

			if (keys1.length !== keys2.length) {
				return false;
			}

			for (let key of keys1) {
				if (!keys2.includes(key) || obj1[key] !== obj2[key]) {
					return false;
				}
			}
			return true;
		}
		
		Vue.prototype.globalDialog = function(name, opt = {}, resolve, cancel) {
			if (typeof opt == 'function') {
				cancel = resolve;
				resolve = opt;
				opt = {};
			}
			
			if (DIALOG_CACHE[name] && !compareObjects(opt.props || {}, DIALOG_CACHE[name].props || {})) {
				DIALOG_CACHE[name].vm.$destroy();
			}
			
			if (!DIALOG_CACHE[name]) {
				DIALOG_CACHE[name] = {props: opt.props};
				let comp = DIALOG.find(comp => comp.name == name);
				if (!comp) return;
				let constructor = Vue.extend(comp);
				DIALOG_CACHE[name].vm = new constructor({
					router,
					store,
					el: document.createElement('div'),
					propsData: opt.props,
					beforeDestroy() {
						delete DIALOG_CACHE[name];
						this.$el.remove();
					}
				});
				document.body.appendChild(DIALOG_CACHE[name].vm.$el);
				DIALOG_CACHE[name].vm.$el.style.position = 'relative';
			}
			
			DIALOG_CACHE[name].vm.$el.style.zIndex = zIndex++;
			DIALOG_CACHE[name].vm.open(opt.data);
			
			let events = {resolve, cancel};
			for (let event in events) {
				DIALOG_CACHE[name].vm.$off(event);
				events[event] && DIALOG_CACHE[name].vm.$on(event, (...params) => {
					events[event].apply(this, params);
				});
			}

			return DIALOG_CACHE[name].vm;
		}

		Vue.prototype.globalDialogDestroy = function() {
			for (let name in DIALOG_CACHE) {
				DIALOG_CACHE[name].vm.$destroy();
			}
		}
	}
}